import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import AppBar from 'components/AppBar';
import BottomNavigation from 'components/BottomNavigation';
import Drawer from 'components/Drawer';
import Footer from 'components/Footer';
import Loader from 'components/Loader';
import FloatedContainer from 'containers/FloatedContainer';
import ImportExport from 'containers/ImportExport';
import ListsAnalysis from 'containers/ListsAnalysis';
import Rankings from 'containers/Rankings';
import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import getTheme from 'themes';
import type { IStore } from 'types/store';
import { ROUTES } from 'utils/urls';

import Wrapper from './Wrapper';

const Home = lazy(() => import('containers/Home'));
const Simulations = lazy(() => import('containers/Simulations'));
const SequenceSimulator = lazy(() => import('containers/SequenceSimulator'));
const PdfContainer = lazy(() => import('containers/PdfContainer'));
const About = lazy(() => import('containers/About'));
const Settings = lazy(() => import('containers/Settings'));

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    justifyContent: 'center',
  },
  inner: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    width: '100%',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
}));

const App = () => {
  const classes = useStyles();
  const config = useSelector((state: IStore) => state.config);

  return (
    <Router>
      <ThemeProvider theme={getTheme(config)}>
        <CssBaseline />
        <div className={classes.root}>
          <AppBar />
          <div className={classes.inner}>
            <Drawer />
            <div className={classes.contentWrapper}>
              <Wrapper>
                <Suspense fallback={<Loader />}>
                  <Switch>
                    <Route exact path={ROUTES.HOME} component={Home} />
                    <Route path={['/units', ROUTES.TARGET, ROUTES.DAMAGE, ROUTES.HEALTH]} component={Home} />
                    <Route exact path={ROUTES.RANKINGS} component={Rankings} />
                    <Route exact path={ROUTES.SIMULATIONS} component={Simulations} />
                    <Route exact path={ROUTES.SEQUENCE_SIMULATOR} component={SequenceSimulator} />
                    <Route exact path={ROUTES.PDF} component={PdfContainer} />
                    <Route exact path={ROUTES.ABOUT} component={About} />
                    <Route exact path={ROUTES.IMPORT} component={ImportExport} />
                    <Route exact path={ROUTES.LISTS_ANALYSIS} component={ListsAnalysis} />
                    <Route exact path={ROUTES.SETTINGS} component={Settings} />

                    <Redirect exact from="/units" to={ROUTES.HOME} />
                    <Redirect from="/advanced" to={ROUTES.SIMULATIONS} />
                    <Redirect to={ROUTES.HOME} />
                  </Switch>
                </Suspense>
              </Wrapper>
              <FloatedContainer />
              <Footer />
            </div>
          </div>
          <BottomNavigation />
        </div>
      </ThemeProvider>
    </Router>
  );
};

export default App;
